<template>
  <div>
    <b-row class="d-flex align-items-center">
      <b-col cols="8">
        <h1 class="font-weight-bolder mb-0">Create SMS Campaign</h1>
      </b-col>
      <b-col cols="4" class="text-right">
        <b-button size="md" variant="outline-secondary" class="mr-1">
          <span class="text-lg text-nowrap" style="margin-left: 4px"
            >Save Draft</span
          >
        </b-button>
        <b-button size="md" variant="primary">
          <span class="text-lg text-nowrap" style="margin-left: 4px"
            >Preview & Send</span
          >
        </b-button>
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col cols="8">
        <b-card border-variant="secondary">
          <b-row>
            <b-col cols="6">
              <p class="font-weight-bold mb-0">Campaign Name</p>
              <b-form-input
                placeholder="e.g. Weekend Promotion"
                v-model="campaignName"
                type="text"
              />
            </b-col>
            <b-col cols="6">
              <p class="font-weight-bold mb-0">Internal Reference Code</p>
              <b-form-input
                placeholder="SMS-2025-06-17"
                v-model="referenceCode"
                type="text"
              />
            </b-col>
          </b-row>

          <b-row class="mt-1">
            <b-col cols="12">
              <p class="font-weight-bold mb-0">Campaign Description</p>
              <b-form-input
                placeholder="Internal description of this campaign..."
                v-model="referenceCode"
                type="text"
              />
            </b-col>
            <b-col cols="6" class="mt-1">
              <p class="font-weight-bold mb-0">Campaign Type</p>
              <v-select
                :value="option"
                :options="options"
                :reduce="(val) => val.value"
                :clearable="false"
                @input="(val) => (option = val.value)"
                class="w-100"
              />
            </b-col>
          </b-row>
        </b-card>

        <b-row>
          <b-col cols="12">
            <b-card border-variant="secondary">
              <h5 class="font-weight-bolder text-body mb-0 text-nowrap">
                Message Composer
              </h5>
              <b-form-textarea
                placeholder="StakeToken: Get a $10 free bet when you place a $20+ bet on this weekend's races! Opt out: reply STOP. T&Cs apply."
                rows="1"
                class="mt-1"
              ></b-form-textarea>
              <div
                class="d-flex align-items-center justify-content-between"
                style="margin-top: 8px"
              >
                <span
                  >Message will be sent as a single SMS (1 credit per
                  recipient)</span
                >
                <span>87/160 characters</span>
                <div>
                  <b-form-checkbox class="d-inline" v-model="checked">
                  </b-form-checkbox>
                  <span>Use AI Assistant</span>
                </div>
              </div>

              <div class="mt-1">
                <p class="font-weight-bold">Message Preview</p>
                <b-card
                  body-class="p-0"
                  style="padding: 8px; margin-bottom: 8px"
                  border-variant="secondary"
                  bg-variant="light"
                >
                  <p class="mb-0">
                    StakeToken: Get a $10 free bet when you place a $20+ bet on this
                    weekend's races! Opt out: reply STOP. T&Cs apply.
                  </p>
                  <span class="text-muted">Delivered • 10:30 AM</span>
                </b-card>
              </div>

              <b-row>
                <b-col cols="6">
                  <v-select
                    :value="option"
                    :options="options"
                    :reduce="(val) => val.value"
                    :clearable="false"
                    @input="(val) => (option = val.value)"
                    class="w-100"
                  />
                </b-col>
                <b-col cols="6">
                  <v-select
                    :value="option"
                    :options="options"
                    :reduce="(val) => val.value"
                    :clearable="false"
                    @input="(val) => (option = val.value)"
                    class="w-100"
                  />
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <b-card border-variant="secondary">
              <h5 class="font-weight-bolder text-body mb-0 text-nowrap">
                Scheduling Options
              </h5>
              <b-form-group v-slot="{ ariaDescribedby }" class="mt-1">
                <b-form-radio-group
                  id="radio-group-1"
                  v-model="selected"
                  :options="options"
                  :aria-describedby="ariaDescribedby"
                  name="radio-options"
                ></b-form-radio-group>
              </b-form-group>

              <b-row>
                <b-col cols="6">
                  <p class="font-weight-bold mb-0">Send Date</p>
                  <flat-pickr
                    id="startDate"
                    v-model="startDate"
                    class="form-control"
                    :config="configDate"
                    placeholder="mm/dd/yyyy"
                  />
                </b-col>
                <b-col cols="6">
                  <p class="font-weight-bold mb-0">Send Time</p>
                  <flat-pickr
                    id="startDate"
                    v-model="time"
                    class="form-control"
                    :config="configTime"
                    placeholder="12:50 PM"
                  />
                </b-col>
                <b-col cols="12" class="mt-1">
                  <b-form-checkbox class="d-inline" v-model="checked">
                  </b-form-checkbox>
                  <span
                    >Suggested send time: Friday at 2:00 PM (highest engagement
                    rate)</span
                  >
                </b-col>
                <b-col cols="12" class="mt-1">
                  <b-form-checkbox class="d-inline" v-model="checked">
                  </b-form-checkbox>
                  <span>Send based on recipient's local time zone</span>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <b-button variant="secondary">Cancel</b-button>
      </b-col>

      <b-col cols="4">
        <b-card border-variant="secondary">
          <b-row>
            <b-col cols="12">
              <h5 class="font-weight-bolder text-body mb-0 text-nowrap">
                Recipient Selection
              </h5>
              <p class="font-weight-bold mb-0 mt-1">Target Audience</p>
              <v-select
                :value="option"
                :options="options"
                :reduce="(val) => val.value"
                :clearable="false"
                @input="(val) => (option = val.value)"
                class="w-100"
              />
              <span class="text-muted"
                >Estimated recipients:
                <strong class="text-muted">12,450 users</strong></span
              >

              <p
                class="text-primary mb-0"
                style="text-decoration: underline; cursor: pointer"
              >
                <feather-icon icon="PlusIcon" />
                Add additional filters
              </p>
            </b-col>

            <div
              class="mt-1 d-flex align-items-center flex-wrap pl-1"
              style="gap: 8px"
            >
              <div
                class="rounded border d-flex align-items-center"
                style="padding: 0 8px; cursor: pointer"
              >
                <p class="font-weight-bolder mb-0 text-nowrap">
                  Location: Australia
                </p>
                <feather-icon icon="XIcon" class="ml-1" />
              </div>
              <div
                class="rounded border d-flex align-items-center"
                style="padding: 0 8px; cursor: pointer"
              >
                <p class="font-weight-bolder mb-0 text-nowrap">
                  Last active: Within 7 days
                </p>
                <feather-icon icon="XIcon" class="ml-1" />
              </div>
              <div
                class="rounded border d-flex align-items-center"
                style="padding: 0 8px; cursor: pointer"
              >
                <p class="font-weight-bolder mb-0 text-nowrap">
                  Location: Australia 324y32
                </p>
                <feather-icon icon="XIcon" class="ml-1" />
              </div>
            </div>

            <div class="d-flex align-items-center pl-1 mt-1">
              <p class="mb-0 mr-1 font-weight-bold">Upload Custom List</p>
              <b-button size="sm" variant="outline-secondary">
                <feather-icon icon="UploadIcon" />
                Upload CSV
              </b-button>
            </div>
          </b-row>
        </b-card>

        <b-card border-variant="secondary">
          <b-row>
            <b-col cols="12">
              <h5 class="font-weight-bolder text-body mb-0 text-nowrap">
                Compliance Management
              </h5>
            </b-col>
            <b-col cols="12">
              <b-form-group v-slot="{ ariaDescribedby }" class="mt-1">
                <b-form-checkbox-group
                  v-model="selected"
                  :options="options"
                  :aria-describedby="ariaDescribedby"
                  name="flavour-2a"
                  stacked
                ></b-form-checkbox-group>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-radio name="radio-size"
                >Australia SMS regulations compliant</b-form-radio
              >
            </b-col>
            <b-col cols="12">
              <span class="text-muted"
                >Message includes required opt-out instructions and sender
                identification</span
              >
            </b-col>
            <b-col cols="12" class="mt-1">
              <p class="font-weight-bold">Frequency Caps</p>
              <v-select
                :value="option"
                :options="options"
                :reduce="(val) => val.value"
                :clearable="false"
                @input="(val) => (option = val.value)"
                class="w-100"
              />
            </b-col>
          </b-row>
        </b-card>

        <b-card border-variant="secondary">
          <b-row>
            <b-col cols="12">
              <h5 class="font-weight-bolder text-body mb-0 text-nowrap">
                Cost Estimate
              </h5>
            </b-col>
            <b-col cols="12" class="mt-1">
              <div class="d-flex align-items-center justify-content-between">
                <span class="text-muted">Recipients:</span>
                <span>12,450</span>
              </div>
              <div class="d-flex align-items-center justify-content-between">
                <span class="text-muted"> Cost per SMS:</span>
                <span>$0.05</span>
              </div>
              <div class="d-flex align-items-center justify-content-between">
                <span>Total estimated cost:</span>
                <span class="font-weight-bolder">$622.50</span>
              </div>
            </b-col>
            <b-col cols="12" class="mt-1">
              <p class="font-weight-bold">Set budget limit</p>
              <b-form-input
                placeholder="Maximum budget (e.g. $1000)"
                v-model="campaignName"
                type="text"
              />
            </b-col>
          </b-row>
        </b-card>
       <b-row>
          <b-col cols="12" class="text-right">
            <b-button size="md" variant="outline-secondary" class="mr-1">
              <span class="text-lg text-nowrap" style="margin-left: 4px"
                >Save Draft</span
              >
            </b-button>
            <b-button size="md" variant="primary">
              <span class="text-lg text-nowrap" style="margin-left: 4px"
                >Preview & Send</span
              >
            </b-button>
          </b-col>
       </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Spinner from "@core/components/Spinner";
import {
  BButton,
  BCard,
  BCol,
  BPagination,
  BRow,
  BButtonGroup,
  BTable,
  BCardBody,
  BFormInput,
  BMedia,
  BAvatar,
  BProgress,
  BProgressBar,
  BFormTextarea,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BFormGroup,
  BImg,
  BFormCheckboxGroup,
  BFormSelect,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";

export default {
  components: {
    BButton,
    BCard,
    BRow,
    BCol,
    BTable,
    BMedia,
    BPagination,
    vSelect,
    Spinner,
    BButtonGroup,
    BTable,
    BCardBody,
    BFormInput,
    BAvatar,
    flatPickr,
    BProgress,
    BProgressBar,
    ValidationProvider,
    ValidationObserver,
    BFormTextarea,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BFormGroup,
    BImg,
    BFormCheckboxGroup,
    BFormSelect,
    FeatherIcon,
  },
  data() {
    return {
      max: 4,
      value: 2,
      campaignName: "",
      referenceCode: "",
      startDate: "",
      endDate: "",
      desc: "",
      configDate: {
        // dateFormat: 'd-m-Y',
        altFormat: "d-m-Y",
        altInput: true,
        static: true,
      },
      time: "",
      configTime: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
      },
      selected: "first",
      options: [
        { text: "Automatically include opt-out instructions", value: "first" },
        { text: "Exclude users who have opted out", value: "second" },
        { text: "Respect Do-Not-Disturb hours", value: "third" },
      ],
      mainProps: {
        blank: true,
        blankColor: "#777",
        width: 32,
        height: 32,
      },
      selected: [],
      optionsCheck: [
        { text: "Homepage Hero", value: "1" },
        { text: "Sidebar", value: "2" },
        { text: "In-App Banner", value: "3" },
        { text: "Email Header", value: "4" },
      ],
    };
  },
  computed: {},
  async mounted() {},
  methods: {},
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
